import fetch from '../../utils/fetch';
import getVatData from './getVatData';
import VatList from './VatList';


const fetcher = () => fetch('/api/config/getVatForCountries.json')
  .then(response => response.json());

export default getVatData({ fetcher })(VatList);
